import { Popup, FlexRow } from '@/ui'
import { useTranslation } from 'react-i18next'
import useModalStore from '@/stores/useModalStore'
import { ReactComponent as IntegrationIcon } from '@/assets/images/icons/link-04.svg'
import IntegrationModal from './IntegrationModal'
import { IntegrationCountContainer } from './Styles'
import zenegyLogo from '@/assets/images/integrations/zenegylogo.png'

interface IntegrationMarkingsProps {
  integrationMarkings?: Array<{
    dataDirection: string
    id: string
    logo: string
    name: string
    isZenegy: boolean
  }>
}

const IntegrationMarkings = ({
  integrationMarkings,
}: IntegrationMarkingsProps) => {
  const { t } = useTranslation()
  if (!integrationMarkings) {
    return null
  }
  return (
    <div
      style={{ marginLeft: 'auto' }}
      onClick={() => {
        useModalStore.getState().openModal({
          header: t('Integrations'),
          body: <IntegrationModal integrationMarkings={integrationMarkings} />,
          size: 'tiny',
        })
      }}>
      <Popup
        content={t('View integration details')}
        inverted
        position="top center"
        trigger={
          <FlexRow
            style={{ cursor: 'pointer', minHeight: '25px' }}
            noMargin
            alignItems="center">
            {integrationMarkings.length === 1 && (
              <img
                src={integrationMarkings[0].logo ?? zenegyLogo}
                style={{
                  width: '22px',
                  top: '0',
                  height: '22px',
                  borderRadius: '4px',
                  border: '1px solid #fff',
                  backgroundColor: '#fff',
                }}
              />
            )}

            {integrationMarkings.length > 1 && (
              <IntegrationCountContainer>
                <IntegrationIcon width="16px" height="16px" />
                <span>{integrationMarkings.length}</span>
              </IntegrationCountContainer>
            )}
          </FlexRow>
        }
      />
    </div>
  )
}

export default IntegrationMarkings
